const zh = {
  'register': {
    'title': '注册,享受企业会员专属权益',
    'many_hotel': '超多酒店',
    'many_hotel_desc': '全球超过7500多个城市, 100多万家酒店',
    'best_sel': '最优选择',
    'best_sel_desc': '整合全球资源，提供最优选择',
    'service_guarantee': '服务保障',
    'service_guarantee_desc': '专业客服团队，值得信赖',
    'home_page': '首页',
    'register': '注册',
    'existing_account': '已有帐号, 立即登录',
    'account_info': '账户信息',
    'user_name': '用户名',
    'enter_user_name': '请输入用户名',
    'password': '密码',
    'enter_password': '请输入密码',
    'confirm_password': '确认密码',
    'enter_confirm_password': '请再次输入密码',
    'enterprise_information': '企业信息',
    'company_name': '公司名称',
    'enter_company_name': '请输入公司名称',
    'city': '所在城市',
    'sel_city': '请选择所在城市',
    'business_license': '营业执照',
    'upload_business_license': '请上传营业执照',
    'contact_information': '联系方式',
    'name': '姓名',
    'enter_name': '请输入姓名',
    'enter_real_name': '请填写真实姓名',
    'phone_number': '手机',
    'enter_phone_number': '请输入手机号',
    'enter_common_phone': '请填写常用手机号, 可用于登录',
    'mailbox': '邮箱',
    'enter_mailbox': '请输入邮箱',
    'enter_common_mailbox': '请填写常用邮箱, 用于找回密码',
    'already_read': '我已阅读并同意',
    'terms_of_ervice': '《服务条款》',
    'privacy_policy': '《隐私政策》',
    'and': '及',
    'submit_registration': '提交注册',
    'register_success': '注册成功',
    'thanks_register': '感谢您的注册申请, 我我们会在1-2个工作日完成审核, 请您耐心等待!',
    'go_home_page': '返回首页'
  },
  'login': {
    'login': '登录',
    'user_name': '用户名/手机号',
    'enter_user_name': '请输入用户名或手机号',
    'password': '密码',
    'enter_password': '请输入密码',
    'login_btn': '登录',
    'code_login': '用户名登录',
    'forgot_password': '忘记密码?',
    'register_now': '立即注册,',
    'get_hotels': '即刻拥有全球海量酒店资源',
    'phone_number': '手机号',
    'enter_phone_number': '请输入手机号',
    'verify': '验证码',
    'enter_verify': '请输入验证码',
    'get_verify': '获取验证码',
    'verify_login': '手机验证码登录'
  },
  'header': {
    'logo': '旅途中的家',
    'booking': '酒店预订',
    'order': '订单管理',
    'order_center': '订单管理',
    'person_center': '个人中心',
    'loginOut': '退出',
    'Reminder': '温馨提示',
    'confirm_login_out': '是否需要退出当前账号',
    'confirm': '确认',
    'cancel': '取消'
  },
  'search': {
    'destination': '目的地',
    'sel_city': '请选择城市',
    'checkIn': '入住日期',
    'checkOut': '离店日期',
    'night': '晚',
    'rooms_and_guests': '房间及住客',
    'room': '房间数',
    'Adult': '成人数(每间)',
    'key_word': '关键词',
    'enter_key_word': '请输入关键词',
    'searchBtn': '搜索',
    'hot_chain': '国内热门城市',
    'hot_oversea': '海外热门城市',
    'southeast_asia': '东南亚',
    'Asia': '亚洲',
    'America': '美洲',
    'Europe': '欧洲',
    'Oceanica': '大洋洲',
    'middle_east_africa': '中东/非洲'
  },
  'hotel_list': {
    'unlimited': '不限',
    'downtown': '商业区',
    'district': '行政区',
    'below_two_stars': '二星级以下/经济',
    'three_star': '三星级/舒适',
    'four_star': '四星级/高档',
    'five_star': '五星级/豪华',
    'less_than_200': '200元以下',
    '200_500': '200~500元',
    '500_1000': '500~1000元',
    '1000_2000': '1000~2000元',
    'more_than_2000': '2000元以上',
    'current': '当前',
    'hotel_counts': '家酒店满足条件, 已为您过滤掉无报价酒店',
    'no_hotels': '暂无酒店, 请换个条件重新搜索',
    'view_details': '查看详情',
    'location': '位置区域',
    'hotel_stars': '酒店星级',
    'price_per_night': '每晚价格'
  },
  'hotel_detail': {
    'show_map': '查看地图',
    'Opening': '开业',
    'see_more': '查看更多',
    'all_facilities': '查看所有酒店设施',
    'Room_type_reservation': '房型预订',
    'checkIn': '入住日期',
    'checkOut': '离店日期',
    'number_of_rooms': '房间数',
    'Occupancy': '入住人数',
    'update': '更新',
    'bed_type': '床型',
    'breakfast': '早餐',
    'king_bed': '大床',
    'Double_bed': '双床',
    'Single_bed': '单人床',
    'Large_double_bed': '大/双床',
    'has_breakfast': '含早餐',
    'Single_breakfast': '单份早餐',
    'Double_breakfast': '双份早餐',
    'All_room_types': '全部房型',
    'Room_type_and_room_description': '房型及房间描述',
    'meals': '餐食',
    'Cancel_the_policy': '取消政策',
    'Average_price_room_night': '均价/间/晚',
    'book': '预订',
    'the_lowest_price': '最低价',
    'Breakfast_not_included': '无餐食',
    'Including_text': '含',
    'breakfast_count': '份早餐',
    'no_cancel': '不可取消',
    'Free_cancellation_before': '前免费取消',
    'total': '总价',
    'Book_Now': '立即预订',
    'Hotel_introduction': '酒店介绍',
    'follow_info': '以下信息基于酒店数据整理得出，供您参考。',
    'Hotel_telephone': '酒店电话',
    'Chinese_address': '中文地址',
    'English_address': '英文地址',
    'Hotel_Profile': '酒店简介',
    'Hotel_facilities': '酒店设施',
    'fac_info': '由于酒店设施可能调整，导致信息更新不及、介绍略有出入，请以实际入住为准。',
    'Hotel_location': '酒店位置'
  },
  'booking': {
    'please': '请在',
    'complete': '内完成填写，以免房间被订完或者价格发生变化',
    'minutes': '分',
    'seconds': '秒',
    'Fill_in': '填写入住信息',
    'Entry_and_departure_time': '入离时间',
    'to': '至',
    'Your_order_number': '贵司订单号',
    'room': '房间',
    'guest': '入住人',
    'last_name': '姓氏',
    'first_name': '名字',
    'keep_common': '姓名需与入住时所持证件一致。',
    'contact_information': '联系人信息',
    'name': '姓名',
    'Select_contacts': '选择联系人',
    'phone_number': '手机',
    'email': '邮箱',
    'send_email': '预订信息将发送到此邮箱',
    'attentions': '注意事项',
    'Booking_prompt': '预订提示',
    'info_confirm': '订单需等酒店或供应商确认后生效，订单确认结果以短信或邮件通知为准。如订单不确认，将自动退还信用额度或全额退款至您的付款账户。',
    'info_price': '所示价格不包含任何适用的住宿服务费、可选杂费（例如迷你吧小吃或打电话）或酒店规定的额外收费。酒店将在您退房时核算这些消费和附加收费。',
    'info_get': '预订服务由深圳市科坦科技有限公司及其合作伙伴提供，住宿服务由酒店提供，交易款项由科坦科技统一收取。',
    'Change_or_cancel': '更改或取消',
    'change_info': '该订单确认后，如需要更改订单信息，包括入住人姓名、日期、床型等，请联系科坦客服确认是否可以操作修改。',
    'Not_arriving_or_late': '未到店或晚至',
    'late_info': '如订单首晚无法到店(No show)或延迟入住请务必联系科坦客服，否则酒店可能不会以任何方式通知客人，并直接取消整单且不退还已收取的预订费用。',
    'Payment_information': '付款信息',
    'yuan': '元',
    'Total_payables': '应付总款',
    'read': '已阅读出行提示和费用说明，并且接受科坦科技的',
    'Reservation_terms': '预订条款',
    'Next_pay': '下一步, 支付',
    'Reservation_information': '预订信息',
    'Expense_details': '费用明细',
    'The_room_rate': '房费'
  },
  'cashier': {
    'order_will': '订单将在',
    'order_close': '后自动关闭，请尽快完成支付！',
    'order_num': '订单号',
    'Total_order_amount': '订单总金额',
    'Credit_limit': '信用额度',
    'Current_available_credit': '当前可用额度',
    'Alipay': '支付宝',
    'Immediate_payment': '立即支付',
    'Room_type_number_of_rooms': '房型间数'
  },
  'center': {
    'Account_Center': '个人中心',
    'Hotel_order': '酒店订单',
    'Hotel_bill_details': '酒店账单明细',
    'Account_information': '账户信息',
    'Account_settings': '账户设置',
    'contact_management': '常用联系人管理',
    'Sub_account_management': '子账号管理',
    'Order_status': '订单状态',
    'all': '全部',
    'Processing': '处理中',
    'Confirmed': '已确认',
    'Canceled': '已取消',
    'Full_house': '满房',
    'Order_Close': '订单关闭',
    'Created': '已创建',
    'fill_in_order_num': '科坦订单号/贵司订单号',
    'Date_selection': '日期选择',
    'Reservation_date': '预定日期',
    'Date_of_check_in': '入住日期',
    'Start_date': '开始日期',
    'End_date': '结束日期',
    'orders': '订单号/确认号',
    'hotel_room_name': '酒店名/房型名',
    'Order_time': '下单时间',
    'Order_amount': '订单金额',
    'check_in_out': '入住/离店日期',
    'operation': '操作',
    'no_data': '暂无数据',
    'Cozytime_order': '科坦订单号',
    'your_order': '贵司订单号',
    'confirmation_number': '酒店确认号',
    'Unpaid': '未付款',
    'Paid': '已付款',
    'Refunded': '已退款',
    'To_be_paid': '待支付',
    'detail': '详情',
    'order_detail': '订单详情',
    'room_type': '房型',
    'Reservation_time': '预订时间',
    'contact_text': '联系人',
    'contact_number': '联系电话',
    'Payment_method': '支付方式',
    'Country_name': '国家名称',
    'Hotel_City': '酒店城市',
    'Hotel_telephone': '酒店电话',
    'hotels_address': '酒店地址',
    'Latest_cancellation_time': '最晚取消时间',
    'Hotel_bill': '酒店账单',
    'Transaction_time': '交易时间',
    'year': '年',
    'month': '月',
    'day': '日',
    'Select_Year': '选择年',
    'Transaction_type': '交易类型',
    'Order_amount': '订单金额',
    'Transaction_date': '交易日期',
    'Credit_line_payment': '信用额度支付',
    'Alipay_payment': '支付宝支付',
    'WeChat_payment': '微信支付',
    'Recharge': '充值',
    'Consumption': '消费',
    'Refund': '退款',
    'User_information': '用户信息',
    'user_name': '用户名',
    'Enterprise_information': '企业信息',
    'Enterprise_No': '企业编号',
    'Enterprise_name': '企业名称',
    'status': '状态',
    'normal': '正常',
    'abnormal': '异常',
    'City': '所在城市',
    'Credit_balance': '授信余额',
    'Settlement_method': '结算方式',
    'Single_settlement': '单结',
    'Monthly_settlement': '月结',
    'Recharge_information': '充值信息',
    'Alipay_transfer': '第一种: 支付宝转账',
    'bank_transfer': '第二种：银行转账',
    'collection_account': '甲方收款账号',
    'account_name': '甲方账户名称',
    'Change_Password': '修改密码',
    'Current_password': '当前密码',
    'old_password': '请输入旧密码',
    'New_password': '新密码',
    'letters_numbers': '大小写字母、数字和特殊字符中至少三种类型混合组成,长度不小于8位',
    'Confirm_Password': '确认密码',
    'password_again': '请再次输入密码',
    'enter_new_password': '请输入新密码',
    'password_format': '请输入正确的密码格式',
    'passwords_differ': '两次输入的密码不一致',
    'save': '保存',
    'confirm_change': '确认要修改密码吗？',
    'login_again': '密码已修改,请重新登录',
    'Modified_successfully': '修改成功',
    'Modify_mailbox': '修改邮箱',
    'Current_mailbox': '当前邮箱',
    'mailbox_format': '请输入正确的邮箱格式',
    'confirm_email': '确认要修改邮箱吗？',
    'emial_change_success': '邮箱修改成功',
    'Top_contacts': '常用联系人',
    'New_reservation_contact': '新增预定联系人',
    'New_contact': '新增联系人',
    'Modify_contact_information': '修改联系人信息',
    'modify': '修改',
    'delete': '删除',
    'phone_formatter': '请输入正确的手机格式',
    'New_contact': '新增联系人',
    'confirm_del': '确认要删除该联系人吗？',
    'Delete_succeeded': '删除成功',
    'Successfully_added': '新增成功',
    'Add_sub_account': '添加子账号',
    'Employee_name': '员工姓名',
    'del_emp': '确认要删除该员工账号吗？',
    'our_service': '筑店服务',
    'HOTEL_RECOMMENDATION': '酒店推荐',
    'confirm_cancel': '确定取消订单？',
    'cancel_failed': '取消失败，请稍后再试',
    'commit_cancel': '已提交申请，请稍后查看',
    'customer_phone': '客服电话',
    'customer_email': '客服邮箱',
    'oa_account': '科坦微信公众号',
    'applet': '酒店预订小程序'
  }
}

export default zh;



// WEBPACK FOOTER //
// ./src/lang/zh_cn.js